// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uAWoJ","content":"styles_content__jFEmB"};